import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const upstash = defineConnector({
  identifier: "upstash",
  name: "Upstash",
  tagLine: "Serverless Redis, Kafka, and queues",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.upstash\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.email,
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Create a management API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Upstash console](https://console.upstash.com/account/api), open **Account › Management API** and create a key.",
        },
      ],
    },
    {
      title: "Enter your Upstash details",
      items: [
        {
          kind: "input",
          label: "Account email",
          required: true,
          target: { kind: "configuration", field: "email" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.upstash.com/v2/redis/databases",
  },
});
